import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Tag, Trash, Plus } from "@phosphor-icons/react";

export const TagsPanel = () => {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () => api.listTags().then(d => setItems(d.items || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async () => {
    const n = name.trim();
    if (!n) return;
    setBusy(true);
    try {
      const r = await api.createTag(n);
      toast.success(r.existed ? `Tag "${r.name}" already exists` : `Tag "${r.name}" created`);
      setName("");
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not create tag");
    } finally {
      setBusy(false);
    }
  };

  const remove = async (t) => {
    if (!window.confirm(`Remove "${t.name}" from saved tags? Contacts already tagged keep it.`)) return;
    await api.deleteTag(t.name);
    toast.success(`Removed "${t.name}" from saved tags`);
    load();
  };

  return (
    <div className="rounded-lg border border-zinc-200 bg-white p-5" data-testid="tags-panel">
      <h3 className="font-heading text-base font-medium mb-1">Tags</h3>
      <p className="text-xs text-zinc-500 mb-3">
        Saved tags appear in tag dropdowns everywhere — even before any contact has them. Tags picked up from contacts show alongside.
      </p>
      <div className="flex items-center gap-2 mb-3">
        <input
          data-testid="new-tag-input"
          value={name}
          onChange={e => setName(e.target.value)}
          onKeyDown={e => e.key === "Enter" && add()}
          placeholder="New tag name, e.g. MediPICs"
          className="h-8 rounded-md border border-zinc-200 px-2 text-sm w-56"
        />
        <button data-testid="create-tag-btn" disabled={busy || !name.trim()} onClick={add} className="text-xs px-3 py-1.5 rounded-md bg-zinc-950 text-white hover:bg-zinc-800 disabled:opacity-50 inline-flex items-center gap-1">
          <Plus size={12}/> Create tag
        </button>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {items.length === 0 && <span className="text-xs text-zinc-400">No tags yet.</span>}
        {items.map(t => (
          <span key={t.name} data-testid={`tag-chip-${t.name}`} className={`inline-flex items-center gap-1.5 text-xs px-2 py-1 rounded-md border ${t.saved ? "border-sky-200 bg-sky-50 text-sky-800" : "border-zinc-200 bg-zinc-50 text-zinc-700"}`}>
            <Tag size={11}/>
            {t.name}
            <span className="text-[10px] opacity-60">{t.count}</span>
            {t.saved && (
              <button onClick={() => remove(t)} title="Remove from saved tags" className="opacity-50 hover:opacity-100 hover:text-rose-700">
                <Trash size={11}/>
              </button>
            )}
          </span>
        ))}
      </div>
    </div>
  );
};
